module.exports = __webpack_public_path__ + "static/media/TRIAL 3 unanswered-after-10-sec.d8b6a4a0.mp3";